import React, { memo } from "react";
import { observer, inject } from "mobx-react";
import { DISPATCH_MAP_FILTERS } from "../constants";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { Marker, Popup } from "../../../../../lib/Map";
import SpottedTrailerMarker from "../../../../mapComponents/Markers/Dispatch/SpottedTrailerMarker";
import { SpottedTrailerPopupInfo } from "../../../../mapComponents/Popups";
import { withSnackbar } from "notistack";
import Events from "../../../../../utilities/EventEmitter";

@inject("DispatchStore")
@observer
class SpottedTrailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOptionSelected: this.isSpottedTrailerSelected(),
      spottedTrailerList: [],
      selectedTrailer: null,
    };
  }

  componentDidMount() {
    this.props.glEventHub.on(
      this.props.headerId + "_multiSelectSelected",
      this.handleCheckBoxSelection
    );
    Events.on("RemoveMapPopup", this.hideTrailerPopup);
    this.props.glEventHub.on(
      "UpdateSpottedTrailers",
      this.updateSpottedTrailer
    );
    Events.on("UpdateSpottedTrailers", this.updateSpottedTrailer);
    this.updateSpottedTrailer();
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      this.props.headerId + "_multiSelectSelected",
      this.filterMapData
    );
    Events.off("RemoveMapPopup", this.hideTrailerPopup);
    this.props.glEventHub.off(
      "UpdateSpottedTrailers",
      this.updateSpottedTrailer
    );
    Events.off("UpdateSpottedTrailers", this.updateSpottedTrailer);
  }

  isSpottedTrailerSelected = () => {
    return this.props.DispatchStore.stopsFilter.includes(
      DISPATCH_MAP_FILTERS.spottedTrailers
    );
  };

  updateSpottedTrailer = (terminalCode = this.props.terminalCode) => {
    if (!this.state.isOptionSelected) {
      return;
    }
    getDataWithQueryString(
      "SpottedTrailer",
      `terminalCode=${terminalCode}`
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          spottedTrailerList: response.data,
        });
      } else {
        this.setState({
          spottedTrailerList: [],
        });
        this.props.enqueueSnackbar(
          `Error while fetching dropped trailers data`,
          {
            variant: "error",
          }
        );
      }
    });
  };

  handleCheckBoxSelection = (options) => {
    const isOptionSelected = options
      .map((option) => option.value)
      .includes(DISPATCH_MAP_FILTERS.spottedTrailers);
    if (this.state.isOptionSelected !== isOptionSelected) {
      this.setState(
        {
          isOptionSelected,
          ...(!isOptionSelected && { selectedTrailer: null }),
        },
        () => {
          if (this.state.spottedTrailerList.length === 0) {
            this.updateSpottedTrailer();
          }
        }
      );
    }
  };

  hideTrailerPopup = () => {
    if (this.state.selectedTrailer) {
      this.setState({
        selectedTrailer: null,
      });
    }
  };

  onTrailerIconClick = (selectedTrailer) => {
    this.setState({
      selectedTrailer,
    });
  };

  render() {
    const { headerId, glEventHub, terminalCode, ...mapProps } = this.props;
    const { isOptionSelected, spottedTrailerList, selectedTrailer } =
      this.state;
    if (!isOptionSelected) {
      return null;
    }
    return (
      <>
        {spottedTrailerList.map((trailer) => {
          const isTrailerSelected =
            selectedTrailer?.data?.trailerNumber === trailer.trailerNumber;
          return (
            <Marker
              {...mapProps}
              position={{
                lat: trailer.latitude,
                lng: trailer.longitude,
              }}
              zIndex={isTrailerSelected ? 3 : 2}
              key={trailer.trailerNumber}
              data={trailer}
              onClick={this.onTrailerIconClick}
            >
              <SpottedTrailerMarker
                backgroundColor={isTrailerSelected ? "white" : "#E5A70D"}
                borderColor={isTrailerSelected ? "#E5A70D" : "white"}
              />
            </Marker>
          );
        })}
        {selectedTrailer && (
          <Popup
            {...mapProps}
            marker={selectedTrailer.marker}
            position={selectedTrailer.position}
          >
            <SpottedTrailerPopupInfo trailerData={selectedTrailer.data} />
          </Popup>
        )}
      </>
    );
  }
}

export default withSnackbar(memo(SpottedTrailers));
